const config = {
  ENVIRONMENT_NAME: 'testing',
  forwoodId: {
    URL: 'https://id.testing.recovery.forwoodsafety.com',
    USER_TOKEN_URL: 'https://g0xsh3rf90.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://a6ivd6xfuj.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'master',
    HOSTNAME: 'https://teams.testing.recovery.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.testing.recovery.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.testing.recovery.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.testing.recovery.forwoodsafety.com',
    WEBSOCKET: 'wss://jlmo7ui728.execute-api.us-west-2.amazonaws.com/testing'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
